<template>
  <div>
    <!-- <div>
      <b-button 
        variant="primary" 
        @click="indexPrognose">Test indexering <b-badge>Beta</b-badge></b-button>
    </div> -->
    <b-table
      :items="rows"
      :fields="columns"
      :small="config.smalltable"
      :tbody-tr-class="tbodyTrClass"
      bordered
      dark
      responsive
      foot-clone
    >
      <template #thead-top>
        <tr>
          <th 
            :colspan="2"
            :rowspan="(config.showHeaderRows ? headerRows.length : 0) +1+(config.showModeratorPanel ? mods.length : 0)"
          >
            Overzicht (Bouwjaar {{ bouwjaar }})
          </th>
          <th class="table-dark">
            Jaren
          </th>
          <th 
            v-for="j in jaartallen" 
            :key="j.key" 
            align="center" 
            class="table-dark"
          >
            {{ j.label }}
          </th>
        </tr>
        <tr
          v-for="(mod,index) in mods"
          v-show="config.showModeratorPanel"
          :key="'moderator-' + index"
        >
          <th>
            <b-checkbox v-model="mod.active">
              <i :class="'fa fa-' + mod.type" />
              {{ mod.type }} {{ mod.jaar }}
            </b-checkbox>
          </th>
          <magnet-block
            v-for="j in jaartallen"
            :key="j.key"
            :mod="mod"
            :jaar="Number(j.label)"
            align="center"
          />
        </tr>
        <template v-if="config.showHeaderRows">
          <tr 
            v-for="(row,index) in headerRows" 
            :key="index"
          >
            <th align="right">
              {{ row.label }}
            </th>
            <td 
              v-for="j in jaartallen" 
              :key="j.key"
            >
              {{ row[j.label] || row.standaard }}
            </td>
          </tr>
        </template>

        <b-modal 
          v-model="showResultaat" 
          ok-only
        >
          {{ totaal }}
        </b-modal>

        <b-modal
          v-if="fotoMap != null"
          v-model="showFotoModel"
          :title="'Foto ' + fotoMap.title"
          size="lg"
          ok-only
          @close="fotoMap = null"
        >
          <b-card-group columns>
            <b-card 
              v-for="(foto,index) in fotos" 
              :key="index" 
              no-body 
              class="mb-3"
            >
              <b-img 
                :src="foto.secure_url" 
                class="card-img-top" 
                @click="kiesFoto(foto)"
              />
              <b-card-body>
                <b-button-toolbar class="icon pull-right">
                  <b-button 
                    size="sm" 
                    @click="kiesFoto(foto)"
                  >
                    selecteren
                    <i class="fa fa-check" />
                  </b-button>
                </b-button-toolbar>
                {{ foto.created_at | formatDateTime }}
                <br>
                <small>{{ foto.public_id.substring(0,30)+".." }}</small>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-modal>
      </template>

      <!-- Default fall-back custom formatted footer cell -->

      <template #head()="data">
        <i v-if="!isNumber(data.label)">{{ data.label }}</i>
        <span v-else>{{ totaal[data.label] || 0 }} </span>
      </template>

      <template #table-caption>
        De bedragen zijn nu zonder BTW weergegeven.
      </template>

      <template #empty>
        <h4>Geen onderdelen gevonden!</h4>
      </template>

      <template 
        #cell(Titel)="data" 
        :style="{'padding-left': data.item.level*15 + 'px'}"
      >
        <b-badge
          v-if="data.item.gebreken.filter((g) => !g.uitgevoerd).length > 0 && config.modus == 'Detail'"
          v-b-tooltip.hover
          :variant="data.item.gebreken.filter((g) => !g.uitgevoerd).length == 1 ? 'warning' : 'danger'"
          title="Aantal gebreken"
          class="pull-right"
        >
          <i class="fa fa-exclamation-triangle" />
          {{ data.item.gebreken.filter((g) => !g.uitgevoerd).length }}
        </b-badge>
      
        <b-form-checkbox
          v-if="config.modus == 'Detail'"
          v-model="data.detailsShowing"
          switch
          @change="data.toggleDetails"
        >
          <i 
            v-if="data.item.isElement" 
            class="fa fa-cubes"
          />
          <i 
            v-else 
            class="fa fa-cube"
          />
          {{ data.item.title }}
          <i 
            v-if="data.item.foto" 
            class="fa fa-photo"
          />
          <i 
            v-if="data.item.import" 
            class="fa fa-link"
          />
          <small
            v-if="getMultiplier(data.item.multiplier) > 1"
          >(x{{ getMultiplier(data.item.multiplier) }})</small>
        </b-form-checkbox>
      
        <b-button-toolbar v-if="config.modus == 'Positie'">
          <b-button-group 
            size="sm" 
            class="mx-1"
          >
            <b-button
              :disabled="data.item.index == 0"
              @click="data.item.move(data.item.index,Number(data.item.index)-1)"
            >
              <i class="fa fa-arrow-up" />
            </b-button>
            <b-button
              :disabled="data.item.canMoveDown(data.item.index)"
              @click="data.item.move(data.item.index,Number(data.item.index)+1)"
            >
              <i class="fa fa-arrow-down" />
            </b-button>
          </b-button-group>
          <b-button-group 
            size="sm" 
            class="mx-1"
          >
            <b-button 
              variant="warning" 
              @click="clipboard = data.item.onCut(data.item.index)"
            >
              <i class="fa fa-cut" />
            </b-button>
            <!---<b-button variant="primary" @click="clipboard = data.item.onCopy(data.item)">
              <i class="fa fa-copy"></i>
            </b-button>--->
            <b-button
              :disabled="clipboard == null"
              variant="primary"
              @click="data.item.onPasteSibling(clipboard)"
            >
              <i class="fa fa-paste" />
            </b-button>
            <b-button
              :disabled="clipboard == null"
              variant="primary"
              @click="data.item.onPasteChild(clipboard)"
            >
              <i class="fa fa-indent" />
            </b-button>
          </b-button-group>
          <b-form-input
            v-model="data.item.title"
            type="text"
            class="w-50"
            placeholder="Naam van het onderdeel"
          />
        </b-button-toolbar>
      </template>

      <template 
        #cell(conditie)="data" 
        align="center"
      >
        <b-button
          :variant="'primary'"
          :class="getConditieClass(getSlechtsteConditie(data.item))"
          size="sm"
        >
          {{ getSlechtsteConditie(data.item) }}
          <i v-if="data.item.maxConditie" class="fa fa-cog fa-xs ml-1" />
        </b-button>
        <sticky-notes 
          :key="data.index" 
          :notes="data.item.acties.concat(data.item.gebreken)" 
          :index="data.index"
        />
      </template>

      <template 
        #cell(jaar)="data" 
        align="center"
      >
        <b-form-input
          v-model.number="data.item.jaar"
          :placeholder="data.item.basejaar.toString()"
          type="number"
          style="width: 70px;"
          size="sm"
        />
      </template>

      <template #cell()="data">
        <cell
          v-if="!data.item.isElement"
          :key="data.field.key + '-' + data.index"
          :row="getResultaatGemodereerd(data.item)"
          :multiplier="getMultiplier(data.item.multiplier)"
          :startjaar="data.item.jaar || data.item.basejaar"
          :jaar="Number(data.field.label)"
        >
          -
        </cell>
        <span v-else>{{ data.field.label }}</span>
      </template>

      <template #row-details="row">
        <onderdeel-card
          :mods="mods"
          :onderdeel="row.item"
          :config="config"
          :fotos="fotoboek"
          :multiplier="getMultiplier(row.item.multiplier)"
          :elementen="elementen"
          :inventarisatie="inventarisatie"
          @foto-selecteren-voor="kiesFotoVoor"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import onderdeelCard from "./OnderdeelCard";
import magnetBlock from "./MagnetBlock";
import JaarInput from "@/components/JaarInput";
import cell from "./Cell";
import { prognoseMixin } from "@/mixins/prognoseMixin";
import { mediaMixin } from "@/mixins/mediaMixin";
import StickyNotes from './onderdeel/StickyNotes.vue';

export default {
  name: 'Matrix',
  components: {
    cell,
    onderdeelCard,
    magnetBlock,
    JaarInput,
    StickyNotes
  },
  mixins: [ prognoseMixin, mediaMixin ],
  props: {
    transpose: {type: Object, default: null},
    footClone: { type: Boolean, default: false },
    smalltable: { type: Boolean, default: true },
    config: { type: Object, default: function()  {
      return {
        showHeaderRows : false,
        showModeratorPanel: false,
        modus: 'Detail',
        jaar: new Date().getFullYear(),
        jaren: 10
      }
    }},
    elementen: { type: Object, default: () => {} },
    headerRows: { type: Array, default: ()=> [] },
    mods: { type: Array, default: () => [] },
    fotoboek: { type: Array, default: () => [] }
  },
  data() {
    return {
      clipboard: null,
      showResultaat: false,
      fotoMap: null,
      showFotoModel: false
    };
  },
  computed: {
    jaartallen() {
      var items = [];
      while (items.length < this.config.jaren) {
        items.push({
          label: (
            Number(Math.round(this.config.jaar)) + items.length
          ).toString(),
          thStyle: {
            "min-width": "55px"
          },
          key: items.length.toString(),
          isRowHeader:
            this.config.jaar + items.length == new Date().getUTCFullYear(),
          variant:
            this.jaar + items.length == new Date().getUTCFullYear()
              ? "info"
              : null
        });
      }
      return items;
    },
    columns() {
      var cols = [
        {
          key: "Titel",
          stickyColumn: true
        },
        {
          key: "conditie",
          label: `Conditie ${this.inclusiefJaar}`,
          stickyColumn: false
        },
        {
          key: "jaar",
          label: "Totaal MJOP",
          stickyColumn: false
        }
      ];

      for (var j in this.jaartallen) {
        cols.push(this.jaartallen[j]);
      }
      return cols;
    },
  },
  watch: {
    'transpose.execute' : function(newVal) {
      console.log(newVal);
      if (newVal == true) {
        console.log("execute.transpose")
        this.transposeExecution()
        this.$emit('transpose-completed');
      }
    }
  },
  methods: {
    tbodyTrClass(item, type) {
      //if (item._showDetails) return "bg-dark";
      if (type == "row-details") return "bg-gray-500";
      if (item.level == 0) return "jaartal-bg";
      if (item.level == 1) return "bg-gray-700";
      if (item.level == 2) return "bg-gray-800";
      if (item.level == 3) return "bg-gray-900";
      if (item.level == 4) return "bg-gray";
      return "bg-red";
    },
    isNumber(value) {
      return !isNaN(value);
    },
    transposeExecution() {
      var matrix_view = this.getPrognoseResultaat(this.rows);
      matrix_view.rijen.forEach((row) => row.acties.forEach((a) => {
        // console.log(a)
        if (a.actie.jaren.map((i) => i.jaar).includes(this.transpose.start) || a.jaren.includes(this.transpose.start)) {
          // verplaats bestaande uitvoeringen jaren
          a.actie.jaren.forEach((item) => { if (item.jaar == this.transpose.start) item.jaar = this.transpose.doel });

          // bestaat planning dan ook die verplaatsen
          if (a.jaren.includes(this.transpose.start)) {
            a.actie.jaren.push({
              jaar: this.transpose.doel,
              uitgevoerd: false,
              stuck: false,
            });
          }
        } else if (this.transpose.create) {
          a.jaren.push({
            jaar: this.transpose.doel,
            uitgevoerd: false,
            stuck: false,
          });
        } 
      }))
    },
    kiesFotoVoor(value) {
      console.dir(value);
      this.fotoMap = value;
      this.getMedia("/unit/" + this.$route.params.id + "/fotos");
      this.showFotoModel = true;
    },
    kiesFoto(foto) {
      this.$set(this.fotoMap, "foto", foto);
      this.showFotoModel = false;
    }
  },
};
</script>
<style>
.jaartal-bg {
  background-color: #515b65;
}
</style>
